import React from "react";
import { Presentation } from "lucide-react";
import type { ColorScheme } from "../types";
import { getSlideColor, getSlideBgColor } from "../utils";

interface LoadingStepProps {
  colorScheme: ColorScheme;
}

export const LoadingStep: React.FC<LoadingStepProps> = ({ colorScheme }) => {
  const primaryColor = getSlideColor(colorScheme);
  const bgColor = getSlideBgColor(colorScheme);

  return (
    <div className="p-12 text-center">
      <div
        className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-6"
        style={{ backgroundColor: bgColor }}
      >
        <Presentation
          className="w-8 h-8 animate-pulse"
          style={{ color: primaryColor }}
        />
      </div>
      <h3 className="text-xl font-bold mb-3 text-(--text-primary)">
        Criando seus slides...
      </h3>
      <p className="text-sm mb-6 text-(--text-tertiary)">
        Nossa IA está criando uma apresentação personalizada para você
      </p>
      <div className="w-64 h-2 bg-(--bg-secondary) rounded-full overflow-hidden mx-auto">
        <div
          className="h-full rounded-full"
          style={{
            width: "100%",
            background: `linear-gradient(90deg, ${primaryColor} 0%, #4a8aff 50%, ${primaryColor} 100%)`,
            backgroundSize: "200% 100%",
            animation: "loading 2s ease-in-out infinite",
          }}
        ></div>
      </div>
      <style>
        {`
          @keyframes loading {
            0% { background-position: 200% 0; }
            100% { background-position: -200% 0; }
          }
        `}
      </style>
    </div>
  );
};
